import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { JmepDiscoverService } from './../../../../service/jmep-discover.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { NotificationService, UserAuth } from '@nrwl/common-lib';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { isEqual, cloneDeep } from 'lodash';

@Component({
  selector: 'nrwl-auto-configuration',
  templateUrl: './auto-configuration.component.html',
  styleUrls: ['./auto-configuration.component.scss'],
  providers: [JmepDiscoverService]
})
export class AutoConfigurationComponent implements OnInit {
  @ViewChild('autoConfigureForm', { static: true }) form: NgForm;
  isLoading = true;
  saveInprogress = false;
  hasReadWriteRole = false;
  actualConfigData = null;
  retrivedConfig = {
    format: 'json',
    id: 'autoConfiguration',
    value: {
      data: []
    }
  };
  saveConfig = {
    format: 'json',
    id: 'autoConfiguration',
    value: {
      data: []
    }
  };
  finalConfig = [];
  factoryDefaultOption = 'Use existing value';
  factoryDefaultConfig = {
    ipAddress: 'Manual',
    selectedARPOption: 'Auto select ESAM interface',
    vlan: 'Not set',
    selectedModeOption: 'Synchronous',
    enableLosPin: 'Enabled',
    selectedDyingGaspOption: 'Disabled',
    enablePingResponse: 'Disabled',
    equipmentInterface: 'Source specific',
    networkInterface: 'Source specific',
    enableViaviHello: 'Enabled'
  };
  autoConfiguration = {
    ipAddress: this.factoryDefaultOption,
    selectedARPOption: this.factoryDefaultOption,
    vlan: '',
    selectedModeOption: this.factoryDefaultOption,
    enableLosPin: this.factoryDefaultOption,
    selectedDyingGaspOption: this.factoryDefaultOption,
    enablePingResponse: this.factoryDefaultOption,
    equipmentInterface: this.factoryDefaultOption,
    networkInterface: this.factoryDefaultOption,
    enableViaviHello: this.factoryDefaultOption
  };
  savedAutoConfiguration = null;
  ARPOptions = [];
  dyingGaspOptions = [];
  timingMode = [];
  loopbackInterface = [];
  ipOption = [
    { name: 'useExistingValue', value: this.factoryDefaultOption },
    { name: 'auto-assign', value: 'Auto-assign' },
    { name: 'manual', value: 'Manual' }
  ];
  private readonly unsubscribe: Subject<void> = new Subject();

  constructor(
    private jmepDiscoverService: JmepDiscoverService,
    public dialogRef: MatDialogRef<AutoConfigurationComponent>,
    private readonly notificationService: NotificationService,
    private readonly userAuth: UserAuth,
    //eslint-disable-next-line
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.hasReadWriteRole = this.userAuth.isAuthedFor('READ_WRITE');
    this.loopbackInterface = this.jmepDiscoverService.getLoopbackInterfaceOptions();
    this.ARPOptions = this.jmepDiscoverService.getARPoptions();
    this.dyingGaspOptions = this.jmepDiscoverService.getDyingGaspOptions();
    this.timingMode = this.jmepDiscoverService.getTimingModeOptions();
    if (this.data?.savedConfigs) {
      this.savedAutoConfiguration = this.data.savedConfigs;
    }
    this.updateAutoConfigs();
    this.isLoading = false;
  }

  //eslint-disable-next-line
  closeModal(savedConfigs?: any): void {
    this.dialogRef.close(savedConfigs);
  }

  updateAutoConfigs(): void {
    if (this.savedAutoConfiguration && Object.keys(this.savedAutoConfiguration)?.length > 0) {
      const configData = this.savedAutoConfiguration?.value?.data;
      for (let i = 0; i < configData.length; i++) {
        this.autoConfiguration[configData[i].name] = configData[i].value;
      }
      this.actualConfigData = cloneDeep(this.autoConfiguration);
      this.updateAutoConfigSelection();
    }
  }

  updateAutoConfigSelection(): void {
    if (
      this.autoConfiguration.ipAddress === this.factoryDefaultConfig.ipAddress ||
      this.autoConfiguration.ipAddress === this.factoryDefaultOption
    ) {
      this.autoConfiguration.selectedARPOption = this.factoryDefaultOption;
      this.autoConfiguration.enablePingResponse = this.factoryDefaultOption;
      this.factoryDefaultConfig.selectedARPOption = 'Disabled';
    } else {
      this.factoryDefaultConfig.selectedARPOption = 'Auto select ESAM interface';
    }
  }

  isDisabledAutoConfig(): boolean {
    return !this.hasReadWriteRole || this.autoConfiguration.ipAddress !== 'Auto-assign';
  }

  validateVlanChange(): void {
    if (this.autoConfiguration.vlan) {
      const vlan = parseInt(this.autoConfiguration.vlan);
      if (vlan >= 1 && vlan <= 4095) {
        this.autoConfiguration.vlan = vlan.toString();
        this.form.controls.vlan.setErrors(null);
      } else {
        this.form.controls.vlan.setErrors({ regex: 'wrong' });
      }
    } else {
      this.form.controls.vlan.setErrors(null);
    }
  }

  saveConfiguration(): void {
    this.saveInprogress = true;
    const retriveExistConfig = this.savedAutoConfiguration;
    if (
      retriveExistConfig &&
      Object.keys(retriveExistConfig)?.length > 0 &&
      retriveExistConfig?.value?.data
    ) {
      this.finalConfig = retriveExistConfig.value.data;
    }
    for (const key in this.autoConfiguration) {
      if (key in this.autoConfiguration) {
        const configIndex = this.finalConfig.findIndex(field => field.name === key);
        if (
          key === 'ipAddress' &&
          (this.autoConfiguration[key] === 'Manual' ||
            this.autoConfiguration[key] === this.factoryDefaultOption)
        ) {
          const arpIndex = this.finalConfig.findIndex(field => field.name === 'selectedARPOption');
          if (arpIndex >= 0) {
            delete this.autoConfiguration.selectedARPOption;
            this.finalConfig.splice(arpIndex, 1);
          }
        }
        if (
          this.autoConfiguration[key] &&
          this.autoConfiguration[key] !== this.factoryDefaultOption
        ) {
          if (configIndex >= 0) {
            this.finalConfig[configIndex].value = this.autoConfiguration[key];
          } else {
            this.finalConfig.push({ name: key, value: this.autoConfiguration[key] });
          }
        } else if (configIndex >= 0) {
          this.finalConfig.splice(configIndex, 1);
        }
      }
    }
    this.saveConfig.value.data = this.finalConfig;
    this.jmepDiscoverService.setAutoConfigData(this.saveConfig);
    this.jmepDiscoverService
      .saveJMEPAutoConfiguration(this.saveConfig)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => {
        this.saveInprogress = false;
        let updatedConfig = null;
        if (res.status === 'success') {
          updatedConfig = this.saveConfig;
          this.notificationService.onSuccess('Auto-configuration has been saved successfully');
        } else {
          this.notificationService.onFail(res?.data?.message);
        }
        this.closeModal(updatedConfig);
      });
  }

  isConfigValueChanged(): boolean {
    return !isEqual(this.actualConfigData, this.autoConfiguration);
  }
}
